import CollectGraphicsFilterForm from "./collect-graphics-filter-form";

const CollectGraphicsForms = {
    Filter: CollectGraphicsFilterForm
};

export default CollectGraphicsForms;
